/// <reference path="../../app.settings.ts" />
module Meevo.Components.CommonClasses {
    export abstract class CommonDataServiceBase implements ICommonDataService {

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService) {

        }

        /**
        * Retrieves a maintenance form section for an item matching the supplied id at the specified endpoint.
        * @param {string} endpoint
        * @return {IPromise<any>}
        */
        getSection(baseEndpoint: string, sectionEndpoint: string): angular.IPromise<any> {
            return this.$http.get(`/${this.appSettings.API_ROOT}/${baseEndpoint}/${sectionEndpoint}`)
                .then((response) => response.data);
        }

        /**
        * Retrieves results for business info on the supplied request.
        * @param {any} request
        * @return {IPromise<any>}
        */
        getListPaged(baseEndpoint: string, request: any): angular.IPromise<any>;
        getListPaged(baseEndpoint: string, request: any, sectionEndpoint?: string): angular.IPromise<any> {
            let uri = "";
            if (sectionEndpoint) {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/${sectionEndpoint}/List/`;
            } else {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/List/`;
            }

            return this.$http.post<any>(uri, request)
                .then((response) => response.data);
        }

        /**
        * Persists an update for the supplied entity.
        * @param {string} sectionEndpoint
        * @return {IPromise<any>} 
        */
        update(baseEndpoint: string, entity: any): angular.IPromise<any>;
        update(baseEndpoint: string, entity: any, sectionEndpoint?: string): angular.IPromise<any> {
            let uri = "";
            if (sectionEndpoint) {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/${sectionEndpoint}`;
            } else {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/`;
            }
            this.preProcess(entity);
            return this.$http.post(uri, entity)
                .then((response) => response.data);
        }

        protected preProcess(entity: any): void {
        }

        /**
       * Retrieves a list of enumerations belonging to the supplied enumType
       * @param {Model.EnumTypeEnum} - enumType
       * return {Model.EnumDto[]>}
       */
        getEnumList(enumType: Model.EnumTypeEnum): angular.IPromise<Model.EnumDto[]> {

            /*  Use this.appSettings.APP_LANGUAGEID When DB Is Ready    */
            let languageId = 1 //this.appSettings.APP_LANGUAGEID

            return this.$http.get(`/${this.appSettings.API_ROOT}/System/Enum/${enumType}?languageId=${languageId}`)
                .then((response: any) => {
                    response.data.forEach((item: Model.EnumDto) => { item.labelId = "ENUM_LABEL_" + item.id; });
                    return response.data;
                });
        }

        /**
         * Gets a template represenation of the object at the specified endpoint.
         * @param baseEndpoint 
         * @returns {} 
         */
        getTemplate(baseEndpoint: string): angular.IPromise<any> {
            let uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/template`;

            return this.$http.get(uri)
                .then((response) => response.data);
        }

        /**
     * Allows the user to customize an API call his their specific needs. 
     * params: uri, method & data
     * @returns {} 
     */
        customMethodData(uri: string, method: string, data: any): angular.IPromise<any>;
        customMethodData(uri: string, method: string, data: any, params?: any): angular.IPromise<any> {
            if (params) {
                return this.$http({
                    url: uri,
                    method: method,
                    params: params,
                    data: data,
                    headers: { "Content-Type": "application/json;charset=utf-8" }
                })
                    .then((res) => {
                        return res;
                    });
            }
            else {
                return this.$http({
                    url: uri,
                    method: method,
                    data: data,
                    headers: { "Content-Type": "application/json;charset=utf-8" }
                })
                    .then((res) => {
                        return res;
                    });
            }

        }

        getCount<TSearch extends Model.SearchCriteria>(baseEndpoint: string, request: Model.SearchCount<TSearch>): angular.IPromise<number>;
        getCount<TSearch>(baseEndpoint: string, request: Model.SearchCount<TSearch>, id?: Guid, sectionEndpoint?: string): angular.IPromise<number> {
            let uri = '';
            if (id && sectionEndpoint) {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/${id}/${sectionEndpoint}/Count/`;
            } else {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/Count/`;
            }

            return this.$http.post<number>(uri, request)
                .then((response) => response.data);
        }

    }
}